import { DateTime } from "luxon";

export function formatRelativeDayLabel(iso: string): string {
  if (!iso) return "";
  let dt: DateTime;
  try {
    dt = DateTime.fromISO(iso);
  } catch {
    return "";
  }

  const day = dt.startOf("day");
  const today = DateTime.now().startOf("day");
  const yesterday = today.minus({ days: 1 });
  const tomorrow = today.plus({ days: 1 });

  if (day.equals(today)) return "Today";
  if (day.equals(yesterday)) return "Yesterday";
  if (day.equals(tomorrow)) return "Tomorrow";

  return dt.toFormat("cccc, LLL d");
}
